export default __webpack_public_path__ + "static/media/Group 4 (1).8c62bbb5.png";